import React from "react"
import { Redirect, useLocation } from "react-router-dom"
import type { ReactElement } from "react"

import { confirmEmailPath, eventsPath, useQuery } from "utilities/routes"
import { User } from "sharedTypes"
import ConfirmEmail from "pages/Unauthenticated/ConfirmEmail"
import ConfirmEmailTokenHandler from "pages/Unauthenticated/ConfirmEmailTokenHandler"
import Spinner from "../elements/Spinner"

export const useConfirmEmailAuthedGate = (
  currentUser: User,
): ReactElement | null => {
  const { pathname } = useLocation()
  const query = useQuery()
  const confirmationToken = query.get("confirmation_token") || ""

  const isOnConfirmEmailPath = pathname === confirmEmailPath()

  if (!currentUser.id) return null

  if (currentUser.confirmed && isOnConfirmEmailPath) {
    if (confirmationToken) {
      return <Spinner />
    }

    return <Redirect to={eventsPath()} />
  }

  if (!currentUser.confirmed && isOnConfirmEmailPath) {
    return <ConfirmEmailTokenHandler currentUser={currentUser} />
  }

  if (!currentUser.confirmed && !isOnConfirmEmailPath) {
    return <ConfirmEmail currentUser={currentUser} />
  }

  return null
}

const ConfirmEmailAuthedGate = ({
  currentUser,
}: {
  currentUser: User
}): ReactElement | null => useConfirmEmailAuthedGate(currentUser)

export default ConfirmEmailAuthedGate
